<div class="metric-snapshot-preview" tabindex="0">
  <span class="assignee-date-wrapper">
    <ui-assignee-avatar *ngIf="snapshot.changedBy" [fromAssigneeId]="snapshot.changedBy" [uiShowTooltip]="true" uiSize="xs"></ui-assignee-avatar>
    <span *ngIf="!snapshot.changedBy">
      <span class="contributor-icon" *ngIf="!!metric.cascadeType.length">
        <i class="fs-20px" [a11yTitle]="'key_result' | localize" ui-icon uiType="metric" uiTheme="fill"></i>
        <span class="cascading-metric-alignment-wrapper">
          <i class="fs-14px sp-ml-12 sp-mt-12" [a11yTitle]="'key_result' | localize" ui-icon uiType="cascading-metric-alignment" uiTheme="fill"></i>
        </span>
      </span>
      <span class="contributor-icon" *ngIf="!metric.cascadeType.length">
        <i class="fs-20px" [a11yTitle]="'key_result' | localize" ui-icon uiType="metric" uiTheme="fill"></i>
      </span>
    </span>
    <span class="snapshot-date">
      {{ snapshot.updatedAt | dayjsDate : "MMMM DD, YYYY, HH:mm" }}&nbsp;
      <span
        class="late"
        *ngIf="snapshot.updatedLate"
        [uiTooltipTitle]="('this_update_was_posted_on' | localize) + (snapshot.createdAt | dayjsDate : 'MMMM DD, YYYY')"
        ui-tooltip
        uiTooltipPlacement="top">
        <i class="fs-12px" ui-icon uiType="clock" uiTheme="outline"></i>
      </span>
    </span>
  </span>
  <span class="confidence-attainment-container">
    <span class="confidence-value" *ngIf="snapshot.confidenceValue" [ngClass]="{ 'confidence-overflow': confidenceOverflow === 'overflow' }"
      ><confidence-preview [confidenceOverflow]="confidenceOverflow" [confidenceValue]="snapshot.confidenceValue" [currentAttainment]="snapshot.currentAttainment"></confidence-preview
    ></span>
    <span
      class="current-attainment"
      [ngClass]="{ 'confidence-overflow': confidenceOverflow === 'overflow', 'attainment-border': confidenceOverflow === 'overflow' }"
      [style.color]="snapshot.view.color"
      >{{ snapshotCurrentAttainmentValue }}%</span
    >
  </span>
</div>

<div class="snapshot-comment-wrapper" tabindex="0">
  <div class="snapshot-comment">
    <div class="snapshot-title">
      <ng-container *featureToggleDisabled="'cascading-krs-confidence-notes'">
        <div class="sp-p-10" *ngIf="snapshotOrigin === 'cascading_update'">
          <div *ngIf="snapshot.sourceInfo.updateReason === 'valueChange'">
            <span class="sp-mr-5">{{ "updated_to_contributed_from" | localize : { value: (snapshot.metricValue | metricValue : metric.format) } }}</span>
          </div>
          <div class="contributor-text" *ngIf="snapshot.sourceInfo.updateReason === 'contributorAdded'">
            <span class="sp-mr-5">{{ "updated_contributing_metric_added" | localize }}</span>
          </div>
          <div class="contributor-text" *ngIf="snapshot.sourceInfo.updateReason === 'contributorDeleted'">
            <span class="sp-mr-5">{{ "updated_contributing_metric_removed" | localize }}</span>
          </div>
          <div class="contributor-text delete" [ngClass]="{ 't-d-line-through': snapshot.sourceInfo.updateReason === 'contributorDeleted' }">
            <i class="fs-16px sp-mr-6 sp-mt-3" ui-icon uiType="contributing-metric" uiTheme="fill"></i>
            <a class="go-to-metric-link sp-mr-24" (click)="goToMetric()">{{ snapshot.sourceInfo.name }}</a>
            <ui-assignee-avatar-group *ngIf="snapshot.sourceInfo.ownerIds.length > 1" [uiMax]="3" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assigneeId of snapshot.sourceInfo.ownerIds" [fromAssigneeId]="assigneeId"></ui-assignee-avatar>
            </ui-assignee-avatar-group>
            <ui-assignee *ngIf="snapshot.sourceInfo.ownerIds.length === 1" [fromAssigneeId]="snapshot.sourceInfo.ownerIds[0]" uiSize="sm"></ui-assignee>
          </div>
        </div>
      </ng-container>

      <ng-container *featureToggleEnabled="'cascading-krs-confidence-notes'">
        <div class="sp-p-10" *ngIf="snapshotOrigin === 'cascading_update'">
          <div *ngIf="snapshot.sourceInfo.updateReason === 'valueChange'">
            <div class="sp-mb-12 font-mediumbold update-to">
              {{ "updated_to_value" | localize : { value: (snapshot.metricValue | metricValue : metric.format) } }}
              <progress-indicator-label
                class="sp-ml-5"
                [uiTooltipTitle]="'improvement_based_on_value_previous_update' | localize"
                [deltaPercentage]="snapshotAttainmentValue"
                [isAccent]="true"
                ui-tooltip
                uiTooltipPlacement="top"></progress-indicator-label>
            </div>
            <div class="sp-mb-2 font-normal">{{ "contributed_from" | localize }}</div>
          </div>
          <div class="contributor-text" *ngIf="snapshot.sourceInfo.updateReason === 'contributorAdded'">
            <span class="sp-mr-5">{{ "updated_contributing_metric_added" | localize }}</span>
          </div>
          <div class="contributor-text" *ngIf="snapshot.sourceInfo.updateReason === 'contributorDeleted'">
            <span class="sp-mr-5">{{ "updated_contributing_metric_removed" | localize }}</span>
          </div>
          <div class="contributor-text" [ngClass]="{ 't-d-line-through': snapshot.sourceInfo.updateReason === 'contributorDeleted' }">
            <i class="fs-16px sp-mr-6 sp-mt-3" ui-icon uiType="contributing-metric" uiTheme="fill"></i>
            <a class="go-to-metric-link sp-mr-24" (click)="goToMetric()">{{ snapshot.sourceInfo.name }}</a>
            <div class="sp-my-12" *ngIf="snapshot.sourceInfo.ownerIds.length > 0">{{ "owner_cap" | localize }}:</div>
            <ui-assignee-avatar-group *ngIf="snapshot.sourceInfo.ownerIds.length > 1" [uiMax]="3" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assigneeId of snapshot.sourceInfo.ownerIds" [fromAssigneeId]="assigneeId"></ui-assignee-avatar>
            </ui-assignee-avatar-group>
            <ui-assignee *ngIf="snapshot.sourceInfo.ownerIds.length === 1" [fromAssigneeId]="snapshot.sourceInfo.ownerIds[0]" uiSize="sm"></ui-assignee>
          </div>
        </div>
      </ng-container>
      <div class="snapshot-section" *ngIf="snapshotOrigin === 'automatic_update'">
        <span>
          <span class="sp-mr-5">{{ "the_value_was_auto_updated_to" | localize }}</span>
          <span class="update-value helper-word-break">{{ snapshot.metricValue | metricValue : metric.format }}</span>
        </span>
        <progress-indicator-label
          class="sp-ml-5"
          [uiTooltipTitle]="'improvement_based_on_value_previous_update' | localize"
          [deltaPercentage]="snapshotAttainmentValue"
          [isAccent]="true"
          ui-tooltip
          uiTooltipPlacement="top"></progress-indicator-label>
      </div>
      <div class="snapshot-section" *ngIf="snapshotOrigin === 'manual_update'">
        <span>
          <ui-assignee-name [fromAssigneeId]="snapshot.changedBy"></ui-assignee-name>
          <span *ngIf="metric.manualType === 'double' || metric.manualType === ''">
            <span class="sp-mr-5">{{ "updated_the_value_to" | localize }}</span>
            <span class="update-value helper-word-break">{{ snapshot.metricValue | metricValue : metric.format }}</span>
          </span>
          <span *ngIf="metric.manualType === 'boolean'">
            <span class="helper-mr-5">{{ "changed_progress_status_to" | localize }}</span>
            <span class="update-value helper-word-break helper-quotes" *ngIf="snapshot.currentAttainment === 1">{{ "achieved" | localize }}</span>
            <span class="update-value helper-word-break helper-quotes" *ngIf="snapshot.currentAttainment === 0">{{ "not_achieved_yet" | localize }}</span>
          </span>
        </span>
        <progress-indicator-label
          class="sp-ml-5"
          [uiTooltipTitle]="'improvement_based_on_value_previous_update' | localize"
          [deltaPercentage]="snapshotAttainmentValue"
          [isAccent]="true"
          ui-tooltip
          uiTooltipPlacement="top"></progress-indicator-label>
      </div>
      <div *ngIf="snapshotOrigin === 'notes_update'"></div>
      <button
        class="delete-checkin-update"
        *ngIf="isAdmin && metric.insightName === '' && metric.cascadeType === '' && !metric.sourceMetricId"
        [uiTooltipTitle]="'delete' | localize"
        (click)="confirmDeleteSnapshot()"
        ui-tooltip
        uiTooltipPlacement="top"
        ui-button>
        <i data-test-id="delete-checkin" ui-icon uiType="trash-bin"></i>
      </button>
    </div>
    <div class="checkin-update-note-container" *ngIf="snapshot.changedBy">
      <i ui-icon uiType="book"></i>
      <div class="checkin-update-note">
        <rich-text-viewer [text]="snapshot.comment"></rich-text-viewer>
        <gif-view class="gif-in-input" [gifSize]="sizeOfGif.Medium" [gif]="snapshot.gif"></gif-view>
      </div>
      <ng-container *ngIf="currentUserId === snapshot.changedBy && !metric.sourceMetricId">
        <button
          class="edit-checkin-update"
          *featureToggleDisabled="'a14-update-key-result'"
          [uiTooltipTitle]="'edit' | localize"
          (click)="goToUpdateMetric()"
          ui-tooltip
          uiTooltipPlacement="top"
          ui-button>
          <i ui-icon uiType="edit"></i>
        </button>

        <button
          class="edit-checkin-update"
          *featureToggleEnabled="'a14-update-key-result'"
          [uiTooltipTitle]="'edit' | localize"
          (click)="openUpdateMetricModal()"
          ui-tooltip
          uiTooltipPlacement="top"
          ui-button>
          <i ui-icon uiType="edit"></i>
        </button>
      </ng-container>
    </div>

    <editable-custom-fields
      *ngIf="snapshot.customFields | objectLength"
      [customFieldValues]="snapshot.customFields"
      [customFieldsFilter]="filterBySessionId"
      [isFieldDisabled]="isCustomFieldDisabled"
      [disableRequired]="true"
      [filterEmptyValues]="true"
      formName="metric-snapshot-form"
      targetType="metric_snapshot">
    </editable-custom-fields>
  </div>
</div>
